import { ENRICHMENT_ANSWER_TYPE_EMAIL } from "../enrichmentAnswerTypes";

export function isEnrichmentAnswerTypeEmail(enrichment) {
    return enrichment.answer_type == ENRICHMENT_ANSWER_TYPE_EMAIL;
}
